import { render, staticRenderFns } from "./Submenu.vue?vue&type=template&id=43fc9146&scoped=true&"
import script from "./Submenu.vue?vue&type=script&lang=ts&"
export * from "./Submenu.vue?vue&type=script&lang=ts&"
import style0 from "../style.scss?vue&type=style&index=0&id=43fc9146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fc9146",
  null
  
)

export default component.exports